<template>
    <BreadCrumb PageTitle="Statistiques et Analyses" />
    <Statistique />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Statistique from "@/components/Statistique/Statistique.vue";

export default defineComponent({
  name: "StatistiquePage",
  components: {
    Statistique,
  },
});
</script>
